<header>
  <!-- Logo -->
  <img
    src="logo_te.svg"
    width="60"
    height="44"
    title="TotalEnergies"
    alt="TotalEnergies"
    class="logo pointer"
    routerLink="/home"
  />

  <!-- Séparateur vertical -->
  <div class="header-separator"></div>

  <!-- Bloc titre -->
  <div class="header-title-block">
    <span class="header-title">MyLogBook</span>
    <span class="header-subtitle">{{ 'header.subtitle' | translate }}</span>
  </div>

  <!-- Spacer -->
  <div class="header-spacer"></div>

  <!-- Section droite -->
  <div class="header-right-section">
    <!-- Impersonation (caché par défaut, visible si canImpersonate) -->
    @if (user() && canImpersonate) {
      <div class="impersonate">
        <mat-form-field>
          <mat-label>{{ 'messages.label.search' | translate }}</mat-label>
          <input type="text" matInput [formControl]="search" [matAutocomplete]="auto" />
          <mat-autocomplete
            #auto="matAutocomplete"
            (optionSelected)="impersonate($event.option.value)"
            [displayWith]="displayUser"
          >
            @for (user of usersToImpersonate(); track user.igg) {
              <mat-option [value]="user"
                >{{ user.igg | uppercase }} - {{ user.firstname }} {{ user.lastname | uppercase }} |
                {{ user.role.label }}</mat-option
              >
            }
          </mat-autocomplete>
          <mat-icon matSuffix color="primary" class="pointer ms-2" svgIcon="total-search" aria-hidden="true"></mat-icon>
        </mat-form-field>
      </div>
    }

    <!-- Séparateur vertical -->
    <div class="header-separator"></div>

    <!-- Avatar utilisateur avec dropdown -->
    @if (user()) {
      <button
        type="button"
        class="user-avatar-container"
        [matMenuTriggerFor]="userMenu"
        [attr.aria-label]="'header.aria.user_menu' | translate"
        aria-haspopup="menu"
      >
        <div class="user-avatar">
          <span class="user-initials">{{ getUserInitials() }}</span>
        </div>
        <mat-icon class="dropdown-arrow" aria-hidden="true">keyboard_arrow_down</mat-icon>
      </button>

      <mat-menu
        #userMenu="matMenu"
        [overlapTrigger]="false"
        role="menu"
        [attr.aria-label]="'header.aria.menu_logout' | translate"
      >
        <!-- Sélecteur de langue dans le dropdown -->
        @if (translateService.getLangs().length > 1) {
          <div class="menu-section-label">{{ 'header.language' | translate }}</div>
          @for (lang of translateService.getLangs(); track lang) {
            <button
              mat-menu-item
              (click)="switchLanguage(lang)"
              [attr.aria-label]="'header.aria.translate_to' | translate: { lang: getLangLabel(lang) }"
            >
              @if (lang === translateService.currentLang) {
                <mat-icon aria-hidden="true">check</mat-icon>
              }
              {{ getLangLabel(lang) }}
            </button>
          }
          <mat-divider></mat-divider>
        }
        <button mat-menu-item [routerLink]="logoutRoute">
          <mat-icon aria-hidden="true">logout</mat-icon>
          {{ 'general.main_menu.logout' | translate }}
        </button>
      </mat-menu>
    }
  </div>

  <!-- Navigation (cachée par défaut via showNavigation) -->
  @if (mpsUserService.isLoggedIn() && showNavigation) {
    <mps-app-navigation></mps-app-navigation>
  }

  <!-- Burger menu mobile -->
  <button
    type="button"
    class="burger-container"
    (click)="nav?.toggle()"
    [attr.aria-expanded]="nav?.opened"
    aria-controls="main-nav"
    [attr.aria-label]="(nav?.opened ? 'header.aria.close_menu' : 'header.aria.open_menu') | translate"
  >
    <mat-icon class="burger menu" [ngClass]="{ active: !nav?.opened }" aria-hidden="true">menu</mat-icon>
    <mat-icon class="burger close" [ngClass]="{ active: nav?.opened }" aria-hidden="true">close</mat-icon>
  </button>
</header>
